import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  flowContainer: {
    padding: theme.spacing(4),
    border: '2px dashed #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#fafafa',
    height: '100vh',
    width: '100%',
    display: 'flex'
  },
  mainOptionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '16px',
    marginBottom: '16px',
    '& > $cardContainer:not(:last-child)': {
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        right: `calc(-${theme.spacing(4)} / 2)`,
        width: `calc(${theme.spacing(4)} / 2)`,
        height: '22px',
        backgroundColor: theme.palette.blue_300.main,
        transform: 'translateY(-50%)',
        zIndex: 1
      }
    }
  },

  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative'
  }, // Linha vertical
  cardTitle: {
    fontSize: '1rem'
  },
  verticalLine: {
    position: 'relative',
    width: '2px',
    height: 50,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main
  },
  cardDepartment: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    borderRadius: '8px',
    padding: '2px',
    minWidth: '120px',
    textAlign: 'center',
    position: 'relative',
    zIndex: 1,
    '&:before': {
      content: 'attr(data-option-number)',
      position: 'absolute',
      top: '-40px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main,
      borderRadius: '50%',
      width: '24px',
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.8rem',
      fontWeight: 'bold'
    }
  },
  cardSubDepartment: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2)
  }, // Botões de ação, como o de adicionar (+)
  optionsButtons: {
    marginTop: theme.spacing(1),
    '& .MuiIconButton-root': {
      backgroundColor: theme.palette.white_100.main,
      border: `2px solid ${theme.palette.blue_300.main}`,
      color: theme.palette.blue_300.main,
      '&:hover': {
        backgroundColor: theme.palette.blue_300.main,
        color: theme.palette.white_100.main
      }
    }
  },
  optionsButtonsPlaceholder: {
    marginTop: theme.spacing(1),
    height: '2rem' // Garante que o espaço ocupado seja o mesmo do botão
  },

  //Nós

  queueNode: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    borderRadius: '8px',
    padding: '2px 16px',
    textAlign: 'center',
    border: 'none'
  },

  '& .react-flow__handle': {
    backgroundColor: 'red'
  },

  addButtonContainer: {
    position: 'absolute',
    left: '50%',
    bottom: '40%',
    transform: 'translate(-50%, -50%)'
  },
  addButton: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    width: '35px',
    height: '35px',
    borderRadius: '50%'
  },

  '& react-flow__viewport': {
    transform: 'translate(461px, 202px) scale(2) !important'
  },

  boxFlow: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    position: 'relative',
    '& .react-flow__viewport': {
      marginTop: '-200px'
    },
    '& .react-flow__controls': {
      display: 'flex',
      flexDirection: 'row',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.gray_100.main,
      padding: '4px',
      borderRadius: '8px',
      border: 'none',
      bottom: 'auto',
      top: '5px',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    // Classe para cada botão individual
    '& .react-flow__controls-button': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_300.main,
      border:
        theme.palette.type === 'dark'
          ? '1px solid' + theme.palette.dark_stroke.main
          : '1px solid' + theme.palette.gray_stroke.main,
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main,
      borderRadius: '4px',
      margin: '2px',
      width: '32px',
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fill: theme.palette.blue_300.main,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.blue_300.main,
        color: theme.palette.white_100.main
      },
      // Botão de FitView (o azul na imagem)
      '&.react-flow__controls-fitview': {
        backgroundColor:
          theme.palette.type === 'dark'
            ? theme.palette.dark_400.main
            : theme.palette.gray_300.main,
        border:
          theme.palette.type === 'dark'
            ? '1px solid' + theme.palette.dark_stroke.main
            : '1px solid' + theme.palette.gray_stroke.main,
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.white_100.main,
        '&:hover': {
          backgroundColor: theme.palette.blue_300.main,
          color: theme.palette.white_100.main
        }
      }
    },
    // Ocultar o ícone oficial da lib (opcional se quiser ícones limpos)
    '& .react-flow__controls-button svg': {
      maxWidth: '14px'
    }
  }
}))
